import React from "react";

const STEPS = [
  { n: "1", text: "You describe the workflow or validation challenge." },
  { n: "2", text: "We assess where AI may help and where control risk appears." },
  { n: "3", text: "We identify likely review and traceability gaps." },
  { n: "4", text: "You receive structured next-step guidance." },
];

const QUESTIONS = [
  "Is the workflow already structured enough for AI-assisted drafting?",
  "Are review responsibilities clear?",
  "Is there a defined handoff from draft to QA review?",
  "Would the final output be traceable and defensible later?",
  "Are you trying to automate a step that should remain human-controlled?",
];

export default function ValidationEvalProcess() {
  return (
    <section className="py-14 sm:py-16 bg-background border-b border-border">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12">
          <div>
            <h2 className="text-2xl sm:text-3xl font-bold text-foreground tracking-tight mb-4">
              How LabComplyx evaluates AI-readiness
            </h2>
            <p className="text-base text-muted-foreground leading-relaxed mb-7">
              LabComplyx approaches AI-assisted quality work as a controlled workflow, not a freeform prompting exercise. Your assessment is framed around the same practical logic: intake, AI draft, QA review, revision, and approved output — with AI limited to the drafting stage rather than final decisions or approvals.
            </p>
            <ol className="space-y-4">
              {STEPS.map((s) => (
                <li key={s.n} className="flex items-start gap-3">
                  <span className="w-7 h-7 rounded-full bg-primary text-primary-foreground text-sm font-bold flex items-center justify-center shrink-0">
                    {s.n}
                  </span>
                  <p className="text-sm text-muted-foreground leading-relaxed pt-1">{s.text}</p>
                </li>
              ))}
            </ol>
          </div>
          <div>
            <h2 className="text-2xl sm:text-3xl font-bold text-foreground tracking-tight mb-4">
              Example questions we assess
            </h2>
            <ul className="space-y-3">
              {QUESTIONS.map((q) => (
                <li key={q} className="flex items-start gap-3 bg-card border border-border rounded-lg p-4">
                  <span className="text-primary font-bold text-sm shrink-0">Q</span>
                  <span className="text-sm text-muted-foreground leading-relaxed">{q}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}